import React from 'react'
import * as T from '../../../components/Table'
import { ValidacaoCaricaturaItem } from './ValidacaoCaricaturaItem'
import { useValidacaoCaricaturaContext } from '../../../contexts/ValidacaoCaricaturaProvider'

export const ValidacaoCaricaturaLista = () => {
  const { query } = useValidacaoCaricaturaContext()

  const { data, isError, isLoading, isRefetching } = query

  const render = {
    isLoading: <LoadingComponent />,
    isError: <ErrorComponent />,
    default: <DefaultComponent data={data} isError={isError} isLoading={isLoading} isRefetching={isRefetching} />,
  }

  return render[isLoading ? 'isLoading' : isError ? 'isError' : 'default']
}

const LoadingComponent = () => (
  <T.Tr>
    <T.TdSkeleton colSpan={3} />
  </T.Tr>
)

const ErrorComponent = () => (
  <T.Tr>
    <T.Td colSpan={3}>Erro ao carregar os dados</T.Td>
  </T.Tr>
)

const DefaultComponent = ({ data }) => data?.map((item) => <ValidacaoCaricaturaItem key={item.numero_pedido} {...item} />)
